// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/retention/public/v1/commands_api.proto (package gdx.retention.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { PerformRetentionActionCommandRequest, PerformRetentionActionCommandResponse } from "./commands_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Retention service.
 *
 * @generated from service gdx.retention.public.v1.CommandsAPIService
 */
export const CommandsAPIService = {
  typeName: "gdx.retention.public.v1.CommandsAPIService",
  methods: {
    /**
     * Perform retention action on user after email transition.
     * In case of unknown action returns INVALID_ARGUMENT
     * When action limit is reached (already used) returns ALREADY_EXISTS
     * Implemented actions "send-gift", "purchase-premium", "purchase-credits"
     *
     * @generated from rpc gdx.retention.public.v1.CommandsAPIService.PerformRetentionActionCommand
     */
    performRetentionActionCommand: {
      name: "PerformRetentionActionCommand",
      I: PerformRetentionActionCommandRequest,
      O: PerformRetentionActionCommandResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

